// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__FLldy","title":"Info_title__2g6rc","selects":"Info_selects__NDe_Z","requiredAsterisk":"Info_requiredAsterisk__2KYIG"};